import { routerPostCall, routerGetCall } from '../../axios';

export const getCartUrl = `/customers/cartData`;

const getCart = (state, params) => {
  const url = getCartUrl;
  const opts = {
    allowGuestSession: true,
  };
  return routerGetCall(state, url, params, opts);
};

const getCartPending = (state, params) => {
  const url = `/customers/myCartPending`;
  return routerGetCall(state, url, params);
};

const addToCart = (state, params) => {
  const url = `/customers/addToCart`;
  return routerPostCall(state, url, params);
};

const addPremiumToCart = (state, params) => {
  const url = `/customers/addPremiumToCart`;
  return routerPostCall(state, url, params);
};

const addLoanToCart = (state, params) => {
  const url = `/customers/addToCart`;
  return routerPostCall(state, url, params);
};

const addRenewalToCart = (state, params) => {
  const url = `/customers/addRenewalToCart`;
  return routerPostCall(state, url, params);
};

const payFirstPremium = (state, params) => {
  const url = `/customers/payFirstPremium`;
  return routerPostCall(state, url, params);
};

const viewReceipt = (state, params) => {
  const url = `/accounts/viewReceipt`;
  const opts = {
    allowGuestSession: true,
  };
  return routerGetCall(state, url, params, opts);
};

const deleteCartItem = (state, params) => {
  const url = `/customers/deleteCartItem`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const orderData = (state, params) => {
  // console.log(params);
  const url = `/accounts/orderDataByContainerId`;
  // const url = `/accounts/orderData`;
  const opts = {
    allowGuestSession: true,
  };
  return routerGetCall(state, url, params, opts);
};

const createOrder = (state, params) => {
  // console.log(params);
  const url = `/customers/createOrder`;
  // const url = `/accounts/orderData`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const checkout = (state, params) => {
  const url = `/customers/checkout`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const changeQuantity = (state, params) => {
  const url = `/customers/changeQuantity`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const changePartialPremium = (state, params) => {
  const url = `/customers/changePartialPremium`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const payNow = (state, params) => {
  const url = `/customers/payNow`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const fac = (state, params) => {
  const url = `/accounts/processPayment`;
  // const url = `/accounts/processFACResponse`;
  const opts = {
    allowGuestSession: true,
  };
  return routerPostCall(state, url, params, opts);
};

const powerTranzAuth = (state, params) => {
  const url = `/accounts/paynow`;
  return routerGetCall(state, url, params);
};

export default {
  getCart,
  getCartPending,
  addToCart,
  addPremiumToCart,
  addLoanToCart,
  addRenewalToCart,
  viewReceipt,
  payFirstPremium,
  deleteCartItem,
  orderData,
  createOrder,
  checkout,
  changeQuantity,
  changePartialPremium,
  payNow,
  fac,
  powerTranzAuth,
};
